export enum ReviewProvider {
    TrustYou = "trustYou",
    TripAdvisor = "tripAdvisor",
}
